export const scrollToAnchor = (location) => {
    const anchor = document.querySelector('#' + location);
    anchor.scrollIntoView({behavior: 'smooth', block: 'start'}) 
}